/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Observable } from 'rxjs';
import { BaseApi } from './BaseApi';

export class ReferenceDataApi extends BaseApi {
  endPoint: string = '/api/admin/reference-data';

  public findByInitiativeId(initiativeId): Observable<any> {
    const dynamicEndPoint = this.endPoint + '/initiativeId/:initiativeId';
    const _routeParams = {
      initiativeId: initiativeId
    };

    return this._get(dynamicEndPoint, _routeParams);
  }
}
